import { getStoredAuthToken } from '@/helpers/set-auth-token';
import { clearAvailableDimensionsCache } from '@/pages/ReportingV2/hooks/useAvailableDimensions';
import store from '@/store';
import { logOut } from '@/store/slices/authSlice';
import { getCurrentWhitelabel } from '@/store/slices/currentWhitelabelSlice';
import axios from 'axios';

export const logoutCleanup = (): void => {
  // Best-effort server-side revoke — logout previously only cleared client-side
  // storage, so a captured token stayed valid for its full lifetime regardless of
  // logout (flank#5116, AUTH-06). The request interceptor runs as an async
  // microtask, AFTER the synchronous clear below already ran — by then there's
  // nothing left for it to read, so the token must be resolved and sent
  // explicitly here, not left to the interceptor (review, Lucas, flank#5117).
  const token = store.getState().auth.token || getStoredAuthToken();
  axios.post('/logout', null, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {
    // Ignored — cleanup proceeds either way.
  });

  sessionStorage.clear();
  localStorage.clear();
  store.dispatch(logOut());
  store.dispatch(getCurrentWhitelabel());
  // Permission-scoped module caches that don't reset on their own — a bare
  // SPA logout/login never reloads the page (review, CodeRabbit, flank#4656).
  clearAvailableDimensionsCache();
};
